const endpoint = 'https://uet-scheduler-proxy.asymmetrical-scenery.workers.dev/base/';
const colorEndpoint = 'https://uet-scheduler-proxy.asymmetrical-scenery.workers.dev/color';
export default endpoint
export { colorEndpoint, endpoint };